import { render, staticRenderFns } from "./DatabaseForm.vue?vue&type=template&id=032e611c"
import script from "./DatabaseForm.vue?vue&type=script&lang=js"
export * from "./DatabaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports